module.exports = __webpack_public_path__ + "media/packs/images/state/small/attention-0b86004e1264e1d861de4dbbb974c155.svg";